// extracted by mini-css-extract-plugin
module.exports = {"communityGrid":"style_communityGrid__kAfTd","communityGrid--socials":"style_communityGrid--socials__Fo1Xf"};